export default __webpack_public_path__ + "static/media/Wave2.3ae63a49.png";